<template>
    <div class="form-items-container col-12 mt-2 pl-1 pr-1">
      <draggable
        v-model="rows"
        tag="div"
        class="row wrap fill-height align-center sortable-list"
      >
        <div
          v-for="row in rows"
          v-show="row.show"
          :key="row.id"
          class="sortable d-flex w-100">

            <div class="question-container">
                <div class="header">
                <app-icon :name="'menu'" width="25" height="25" class="float-right handle-question btn btn-primary btn-sm btn-circle btn-circle-xs"/>
                <app-input id="inputs_name"
                        class="name col-sm-9 p-0"
                        :placeholder="$t('form_question')"
                        type="textarea"
                        v-model="row.question[0].title[0].cz"/></div>

                        <div class="option text-muted">
                            <div class="col-sm-1">{{ $t('form_order') }}</div>
                            <div class="col-sm-7">{{ $t('form_possible_answers') }}</div>
                            <div class="col-sm-1 pl-0">{{ $t('form_answer_type') }}</div>
                            <div class="col-sm-3">{{ $t('form_correct_answer') }}</div>
                        </div>

              <draggable
                :list="row.answers"
                tag="div"
                :group="{ name: 'group-'+row.id }"
                class="wrap justify-space-around p-0"
                ghost-class="ghost"
                handle=".handle">

                <div
                  v-for="answer in row.answers"
                  :key="answer.id"
                  class="option"
                  :class="answer.show ? '' : 'option-hidden'">

                  <div class="col-sm-1">
                      <app-icon :name="'menu'" width="25" height="25" class="float-right handle"/>
                  </div>

                  <div class="col-sm-7">
                      <app-input
                           class="name"
                           :placeholder="$t('form_answer_text')"
                           v-model="answer.title[0].cz"
                           type="textarea"/>


                  </div>
                  <div class="col-sm-1 pl-0 answer-container">
                      <div @click.prevent="setType(row.id, answer.id, 'radio')" :class="answer.type == 'radio' ? 'active' : ''" :title="$t('form_type_radio')">
                          <app-icon :name="'check-square'" width="22" height="22" class="answer-type" />
                      </div>
                      <div  @click.prevent="setType(row.id, answer.id, 'text')" :class="answer.type == 'text' ? 'active' : ''" :title="$t('form_type_text')">
                          <app-icon :name="'message-square'" width="22" height="22" class="answer-type"/>
                      </div>
                  </div>


                  <div class="col-sm-2 answer" v-if="answer.correct == 1">
                      <div class="questionnaire-mark questionnaire-mark-perfect"></div>
                  </div>
                  <div class="col-sm-2 answer cursor-pointer" v-else-if="answer.correct == 0" @click.prevent="setCorrectAnswer(row.id, answer.id)" :title="$t('set_correct_answer')">
                      <div class="questionnaire-mark questionnaire-mark-wrong"></div>
                  </div>

                  <!-- @todo: až budou spustěné formuláře s možností checkbox -->
                  <!--
                  <app-input id="inputs_timeline_state"
                             class="large-input"
                             type="select"
                             :title="$t('timeline_state')"
                             v-model="answer.correct"
                             :list="answerResult"
                             :required="true"/>

                  <button  class="btn btn-primary btn-sm" >{{ $t('set_correct_answer') }}</button> -->



                  <button class="col-sm-1 btn destroy" @click.prevent="answer.show = 0"><app-icon :name="'trash'" width="20" height="20"/></button>
                </div>
              </draggable>

              <div class="option option-add w-100 d-flex col-xs-4">
                  <button class="btn btn-primary btn-sm" @click.prevent="addAnswer(row.id)">{{ $t('form_add_option') }}</button>
              </div>

          </div>

        </div>
      </draggable>

      <div class="w-100 text-center mt-4">
          <button class="btn btn-primary" @click.prevent="addQuestion(rows.length+1)">+ {{ $t('form_add_question') }}</button>
      </div>

    </div>

</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "Form",
  order: 17,
  components: {
      draggable
  },
  props: {
      initialRows: {
          required: false,
          type: [Array, String],
      },
  },
  watch: {
    rows: {
      immediate: true,
      deep: true,
      handler (val, oldVal) {

          if(oldVal){
              this.$emit('getFormData', JSON.stringify(val));
          }

      }
    },

  },
  data() {
    return {
      enabled: true,
      answerResult: [
          {id: 1, value: this.$t('correct')},
          {id: 0, value: this.$t('wrong')},
      ],
      optionsType: [
          {id: 'radio', value: this.$t('form_radio')},
          //{id: 'checkbox', value: this.$t('form_checkbox')},
          //{id: 'textarea', value: this.$t('form_textarea')},
      ],
      selectedOptionType: 'radio',
      rows: [],
    };
  },
    mounted() {
        if(this.initialRows){
            if(Array.isArray(this.initialRows)){
                this.rows = this.initialRows;
            } else {
                this.rows = JSON.parse(this.initialRows);
            }

        }

    },
    methods: {
        /**
         * Actions
         * */

        addQuestion(id) {
            this.rows.push({
              id: id,
              show: 1,
              question: [
                {
                    id: 1,
                    required: 1,
                    title: [
                        {
                            cz: "",
                            sk: "",
                            en: ""
                        }
                    ]
                }
              ],
              answers: [
                {
                    id: 1,
                    correct: 1,
                    type: 'radio',
                    show: 1,
                    title: [
                        {
                            cz: "",
                            sk: "",
                            en: ""
                        }
                    ]
                },
                {
                    id: 2,
                    correct: 0,
                    type: 'radio',
                    show: 1,
                    title: [
                        {
                            cz: "",
                            sk: "",
                            en: ""
                        }
                    ]
                }
              ]
            });
        },
        setType(selectedRowId, selectedAnswerId, type) {
            let selectedRow = this.rows.findIndex((row => row.id == selectedRowId));

            this.rows[selectedRow].answers.forEach((e, i) => {

               if (e.id == selectedAnswerId) {
                   this.rows[selectedRow].answers[i].type = type;
               }
            });


        },
        setCorrectAnswer(selectedRowId, selectedAnswerId) {
            let selectedRow = this.rows.findIndex((row => row.id == selectedRowId));

            this.rows[selectedRow].answers.forEach((e, i) => {

               if (e.id == selectedAnswerId) {
                   this.rows[selectedRow].answers[i].correct = 1;

               } else {
                   this.rows[selectedRow].answers[i].correct = 0;
               }
            });


        },
        addAnswer(selectedRowId) {
            let selectedRow = this.rows.findIndex((row => row.id == selectedRowId));
            let totalAnswers = this.rows[selectedRow].answers;

            this.rows[selectedRow].answers.push({
                    id: totalAnswers.length+1,
                    correct: 0,
                    type: 'radio',
                    show: 1,
                    title: [
                        {
                            cz: "",
                            sk: "",
                            en: ""
                        }
                    ]
            });

        },


        /**
         * Get additional data
         * */


    },
};
</script>
<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
